module.exports = __webpack_public_path__ + "img/pic_03@2x.03be95b6.png";